import { render, staticRenderFns } from "./TransferFamilyUserForm.vue?vue&type=template&id=5b5416f1&scoped=true"
import script from "./TransferFamilyUserForm.vue?vue&type=script&lang=js"
export * from "./TransferFamilyUserForm.vue?vue&type=script&lang=js"
import style0 from "./TransferFamilyUserForm.vue?vue&type=style&index=0&id=5b5416f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5416f1",
  null
  
)

export default component.exports